import { render, staticRenderFns } from "./PendingInfo.vue?vue&type=template&id=13ab489e&scoped=true"
import script from "./PendingInfo.vue?vue&type=script&lang=js"
export * from "./PendingInfo.vue?vue&type=script&lang=js"
import style0 from "./PendingInfo.vue?vue&type=style&index=0&id=13ab489e&prod&lang=css"
import style1 from "./PendingInfo.vue?vue&type=style&index=1&id=13ab489e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab489e",
  null
  
)

export default component.exports